/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Type/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Type({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentPayments/Content/Content/DefaultPayorSchedule/PaymentPlanLength/Type"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let settingsDataDefaultPayorSchedulePaymentPlanLengthTypeValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'data.default_payor_schedule.payment_plan_length.type',
})
let constantData = 'TOTAL'
let aggregateData = fromAggregate.equals(settingsDataDefaultPayorSchedulePaymentPlanLengthTypeValueData, constantData)
let settingsDataDefaultPayorScheduleTypeValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'data.default_payor_schedule.type',
})
let constantData1 = 'PAYMENT_PLAN_LENGTH'
let aggregateData1 = fromAggregate.equals(settingsDataDefaultPayorScheduleTypeValueData, constantData1)
let onClick = fromHelpers.useOnClickTotal({
  children,
  viewPath
  
})
let settingsDataDefaultPayorSchedulePaymentPlanLengthTypeValueData1 = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'data.default_payor_schedule.payment_plan_length.type',
})
let constantData2 = 'RELATIVE'
let aggregateData2 = fromAggregate.equals(settingsDataDefaultPayorSchedulePaymentPlanLengthTypeValueData1, constantData2)
let settingsDataDefaultPayorScheduleTypeValueData1 = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'data.default_payor_schedule.type',
})
let constantData3 = 'PAYMENT_PLAN_LENGTH'
let aggregateData3 = fromAggregate.equals(settingsDataDefaultPayorScheduleTypeValueData1, constantData3)
let onClick1 = fromHelpers.useOnClickRelative({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Type.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-bxIu': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<Radial
  viewPath={`${viewPath}/Radial`}
 onClick={onClick}
 data="settings.data.default_payor_schedule.payment_plan_length.type"
 data="'TOTAL'"
 aggregate="/Data/aggregate equals"
 isSelected={aggregateData}
 data="settings.data.default_payor_schedule.type"
 data="'PAYMENT_PLAN_LENGTH'"
 aggregate="/Data/aggregate equals"
 isDisabled={!aggregateData1}
 text="Total"
/>
<Radial
  viewPath={`${viewPath}/Radial`}
 onClick={onClick1}
 data="settings.data.default_payor_schedule.payment_plan_length.type"
 data="'RELATIVE'"
 aggregate="/Data/aggregate equals"
 isSelected={aggregateData2}
 data="settings.data.default_payor_schedule.type"
 data="'PAYMENT_PLAN_LENGTH'"
 aggregate="/Data/aggregate equals"
 isDisabled={!aggregateData3}
 text="Relative"
/>
</div>
{children}
</React.Fragment>)
}